module.exports = __webpack_public_path__ + "static/fonts/PingFang_Regular.75225b29.ttf";